import 'core-js';
import 'react-app-polyfill/stable';
import { cilX } from '@coreui/icons';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { closeSnackbar, SnackbarProvider } from 'notistack';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import NotificationSnack from './components/Component/NotificationSnack';
import reportWebVitals from './reportWebVitals';
import store, { persistor } from './store';

import CIcon from '@coreui/icons-react';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')).render(
  <QueryClientProvider client={queryClient}>
    <SnackbarProvider
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      Components={{ notification: NotificationSnack }}
      action={(snackbarId) => (
        <div onClick={() => closeSnackbar(snackbarId)}>
          <CIcon icon={cilX} width={20} height={20} className="bg-primary-color rounded-5 p-1" />
        </div>
      )}
    >
      <Provider store={store}>
        {/* ⚡ Remove loading prop - app renders immediately while rehydrating */}
        <PersistGate persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </SnackbarProvider>
  </QueryClientProvider>,
);

reportWebVitals();
